import React from "react"
import ApplicationForm from "../applicationForm/applicationForm"
import './applyNowPage.css'

const ApplyNowPage = () => {
  return (
    <div className="apply-now-page">
      <h2 className="apply-title">Apply Now</h2>
      <ApplicationForm />
    </div>
  )
}

export default ApplyNowPage
